import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Dropdown } from 'antd';
import { ChevronDown, LogOut, UserPen } from 'lucide-react';

import { authReducerActions } from '../../store/reducers';
import { useLogout } from '../../hooks';
import { ROUTE_URLS } from '../../routes';
import { createLink } from '../../utils';
import { useI18n } from '../../i18n';

export const UserMenu = () => {
  const { user, isAdmin } = useSelector(state => state.authReducer);
  const { mutateAsync: logoutUserRQ } = useLogout();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useI18n();

  const logout = () => {
    dispatch(authReducerActions.logoutUser());
    logoutUserRQ();
  };

  const login = user?.login ?? '';
  const role = isAdmin ? t('header.administrator') : t('header.employee');

  const items = [
    {
      key: 'head',
      disabled: true,
      style: { cursor: 'default', background: 'transparent' },
      label: (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '2px 0 6px', minWidth: 200 }}>
          <span className='wm-avatar wm-avatar--lg'>{login.slice(0, 2)}</span>
          <span style={{ minWidth: 0 }}>
            <div className='wm-strong' style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {login}
            </div>
            <div className='wm-muted' style={{ fontSize: 12 }}>
              {role}
            </div>
          </span>
        </div>
      ),
    },
    { type: 'divider' },
    {
      key: 'profile',
      icon: <UserPen size={15} strokeWidth={1.75} />,
      label: t('header.editProfile'),
      onClick: () => navigate(createLink(ROUTE_URLS.EDIT_USER, user.id)),
    },
    {
      key: 'logout',
      danger: true,
      icon: <LogOut size={15} strokeWidth={1.75} />,
      label: t('header.logout'),
      onClick: logout,
    },
  ];

  return (
    <Dropdown trigger={['click']} placement='bottomRight' menu={{ items }}>
      <button type='button' className='wm-user-btn' aria-label={t('header.profile')}>
        <span className='wm-avatar'>{login.slice(0, 2)}</span>
        <span className='wm-user-btn__name wm-hide-md'>{login}</span>
        <ChevronDown size={14} strokeWidth={2} className='wm-muted wm-hide-md' />
      </button>
    </Dropdown>
  );
};
